import type { DateValue } from '@internationalized/date';
import { CalendarDate, getLocalTimeZone, today } from '@internationalized/date';
import type { Ref } from 'vue';
import { ref } from 'vue';

export const createDateValueRef = <DV extends DateValue>(dateValue: DV): Ref<DV | undefined> => {
    const dateValueRef = ref<DV>();
    dateValueRef.value = dateValue;
    return dateValueRef;
};

export const createToday = (): DateValue => {
    return today(getLocalTimeZone());
};

export const createCalendarDate = (year: number, month: number, day: number): DateValue => {
    return new CalendarDate(year, month, day);
};

export const createCalendarDateFromJS = (jsDate: Date): DateValue => {
    return new CalendarDate(
        jsDate.getFullYear(),
        jsDate.getMonth() + 1, // Convert 0-based to 1-based month
        jsDate.getDate(),
    );
};

export const calendarDateToNativeDate = (dateValue: DateValue, timeZone: string = getLocalTimeZone()): Date => {
    const tz = timeZone;
    return dateValue.toDate(tz);
};

const shiftBusinessDays = (date: DateValue, direction: 1 | -1, days: number): DateValue => {
    let current = date;
    let count = 0;
    while (count < days) {
        current = current.add({ days: direction });
        const dayOfWeek = current.toDate(getLocalTimeZone()).getDay();
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
            count++;
        }
    }
    return current;
};

export const addBusinessDays = (date: DateValue, days: number): DateValue => shiftBusinessDays(date, 1, days);

export const subtractBusinessDays = (date: DateValue, days: number): DateValue => shiftBusinessDays(date, -1, days);
